export var isOwningElement = function (owningElement, element) {
    if (!owningElement || !element)
        return false;
    if (owningElement.contains(element))
        return true;
    var attribute = 'aria-owns';
    var getOwnedElementIds = function (owning) { var _a, _b; return (_b = (_a = owning.getAttribute(attribute)) === null || _a === void 0 ? void 0 : _a.split(' ')) !== null && _b !== void 0 ? _b : []; };
    var ownedIds = getOwnedElementIds(owningElement);
    if (ownedIds.some(function (id) { return document.getElementById(id) === element; }))
        return true;
    var owners = owningElement.querySelectorAll("[".concat(attribute, "]"));
    return Array.from(owners).some(function (owner) {
        return getOwnedElementIds(owner).some(function (id) { var _a; return ((_a = document.getElementById(id)) === null || _a === void 0 ? void 0 : _a.contains(element)) === true; });
    });
};
